import React from 'react';
import { Box, Typography,Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const SuccessPage =()=>{
    const navigate = useNavigate();

    const handleGotoLoginPage =()=>{
        navigate('/login')
    }

    return(
        <Box className='login-box'>
        <Box sx={{ textAlign: 'center'}}>

        <img
            src={"logo.svg"}
            alt="logo"
            style={{ cursor: "pointer", marginBottom: '24px' }}
          />

           <Box>
           <img
            src={"successForgotPassIcon.gif"}
            alt="logo"
            height={150}
            width={150}
            style={{ cursor: "pointer" }}
          />
           </Box>
  
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 700,
            fontSize: "24px",
            lineHeight:"29.05px",
            color:'#E2E3E3',
            marginTop:'32px'
          }}
        >
          Password set successfully
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: "16px",
            lineHeight:"19.36px",
            color:'#B4B7B8',
            margin: '15px 0px'
          }}
        >
          Log into your account with your new password
        </Typography>
        <Button type="submit" variant="contained" sx={{ padding: '12px 16px', fontSize: '14px', fontWeight: 500,color:'#1F2F34',width:'100%',marginTop:'23px' }} className='auth-btn' onClick={handleGotoLoginPage}>
            Go To Login Page
        </Button>
        </Box>
      </Box >
    )
}
export default SuccessPage;